import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexRenderDirective } from '@tanstack/angular-table';
import { DatatableComponent } from './datatable/datatable.component';
import { DatatablePaginationComponent } from './datatable-pagination/datatable-pagination.component';
import { DatatableHeadSelectionComponent } from './datatable-head-selection/datatable-head-selection.component';
import { DatatableRowSelectionComponent } from './datatable-row-selection/datatable-row-selection.component';
import { DatatableSortableColumnHeaderComponent } from './datatable-sortable-column-header/datatable-sortable-column-header.component';
import { DatatableRowActionsComponent } from './datatable-row-actions/datatable-row-actions.component';
import { DatatableEmptyComponent } from './datatable-empty/datatable-empty.component';
import { DatatableResizableHeaderDirective } from './datatable-resizable-header/datatable-resizable-header.directive';
import { DatatableResizableCellDirective } from './datatable-resizable-cell/datatable-resizable-cell.directive';

const MODULES = [
  DatatableHeadSelectionComponent,
  DatatableRowSelectionComponent,
  DatatableRowActionsComponent,
  DatatablePaginationComponent,
  DatatableSortableColumnHeaderComponent,
  DatatableEmptyComponent,
  FlexRenderDirective,
  CommonModule,
  DatatableComponent
];

const DIRECTIVES = [
  DatatableResizableHeaderDirective,
  DatatableResizableCellDirective
];

@NgModule({
  imports: [...MODULES, ...DIRECTIVES],
  exports: [...MODULES, ...DIRECTIVES]
})
export class DatatableModule {}
